import { Flex, Image } from "@mantine/core";
import "./Logo.css";

export function Logo({ size = 24 }: { size?: number }) {
  return (
    <Flex align="center" gap="sm" className="logo">
      <Image
        width={size}
        height={size}
        style={{ objectFit: "contain", width: size, height: size }}
        src="/logo.png"
        alt="167BC"
      />
    </Flex>
  );
}
